module.exports = __webpack_public_path__ + "static/media/Orbitron-VariableFont_wght.c641d3e9.ttf";